import * as AuthQueries from './auth-queries';
import * as CreditQueries from './credit-queries';
import * as Errors from './errors';
import * as EventQueries from './event-queries';
import * as InvoiceQueries from './invoice-queries';
import * as LocationQueries from './location-queries';
import * as OperatorQueries from './operator-queries';
import * as PaymentQueries from './payment-queries';
import * as ProductQueries from './product-queries';
import * as UserQueries from './user-queries';

export {
  AuthQueries,
  CreditQueries,
  EventQueries,
  Errors,
  InvoiceQueries,
  LocationQueries,
  OperatorQueries,
  PaymentQueries,
  ProductQueries,
  UserQueries
};

export * from './types';
